module.exports = __webpack_public_path__ + "static/media/image-mask-small-mirror.45280905.svg";